"use strict";
import { notificationConstants } from "../_constants";

import { from, of } from "rxjs";
import { ajax } from "rxjs/ajax";
import { ofType } from "redux-observable";
import {
  mergeMap,
  switchMap,
  catchError,
  map,
  concatMap,
} from "rxjs/operators";

import { getRequestHeader } from "../../_helpers/request.header";
import {
  notificationDetailComplete,
  notificationDetailError,
  notificationListComplete,
  notificationListError,
  notificationUpdateComplete,
  notificationUpdateError,
  notificationUnreadCountComplete,
  notificationUnreadCountError,
  ajaxError,
  notificationUnreadCountRequest,
} from "../_actions";
import i18n from "../../i18n";

export const notificationListsEpic = (actions$) =>
  actions$.pipe(
    ofType(notificationConstants.NOTIFICATION_LIST_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/notifications/getNotificationList",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            notificationListComplete(ajaxResponse.response),
          ),
          catchError((error) =>
            of(notificationListError(error), ajaxError(error)),
          ),
        );
    }),
  );

export const notificationDetailsEpic = (actions$) =>
  actions$.pipe(
    ofType(notificationConstants.NOTIFICATION_DETAIL_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/notifications/getNotificationDetails",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            notificationDetailComplete(ajaxResponse.response),
          ),
          catchError((error) =>
            of(notificationDetailError(error), ajaxError(error)),
          ),
        );
    }),
  );

export const notificationUpdateEpic = (actions$) =>
  actions$.pipe(
    ofType(notificationConstants.NOTIFICATION_UPDATE_REQUEST),
    mergeMap((action) =>
      ajax
        .post(
          "/api/notifications/updateNotification",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          mergeMap((ajaxResponse) =>
            of(
              notificationUpdateComplete(ajaxResponse.response),
              notificationUnreadCountRequest({ locale: i18n.language }),
            ),
          ),
          catchError((error) =>
            of(notificationUpdateError(error), ajaxError(error)),
          ),
        ),
    ),
  );

export const notificationUnreadCountEpic = (actions$) =>
  actions$.pipe(
    ofType(notificationConstants.NOTIFICATION_UNREAD_COUNT_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/notifications/getNotificationUnreadCount",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            notificationUnreadCountComplete(ajaxResponse.response),
          ),
          catchError((error) => of(notificationUnreadCountError(error))),
        );
    }),
  );
